export default __webpack_public_path__ + "static/media/user_profile_icon.ff788981.png";